/* eslint-disable eqeqeq */
/* eslint-disable no-trailing-spaces */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  Platform,
} from '@ionic/angular';
import { UserApiService } from '../services/user-api.service';
 import { LocalStorageService } from '../services/core/local-storage.service';
import { GlobalVariable } from '../global';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { AuthRedirectServiceService } from '../services/navigationAuth/auth-redirect-service.service';
interface LoginData {
  email: String;
  password: String;
}
@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {


  loginData: LoginData;
  loginForm: FormGroup;
  isSubmitted = false;
  loading;
  PassType: string = 'password';

  constructor(
    private loginApi: UserApiService,
    private router: Router,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private navCTRL: NavController,
    public fb: FormBuilder,
    private localStorageService: LocalStorageService,
    public globals: GlobalVariable,
    public modalCtrl: ModalController,
    public nativeStorage: NativeStorage,
    private platform: Platform,
    private authRedirectService: AuthRedirectServiceService,
    
  ) {
    this.loginData = {} as LoginData;
  }

  ngOnInit() {    
    this.loginForm = this.fb.group({
      email: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
        ])
      ),
      password: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.minLength(6)])
      ),
    });
  }

  async signIn() {
    let cleanEmail = this.loginForm.value.email.trim();
    this.loginForm.get('email').setValue(cleanEmail);
    console.log(cleanEmail, this.loginForm.value.email);

    this.isSubmitted = true;
    if (!this.loginForm.valid) {
      console.log('Please provide all the required values!');
      return false;
    } else {
      console.log(this.loginForm.value);
    }
    
    // this.pageLoading();

    this.loginApi
      .customerLogin(this.loginForm.value.email, this.loginForm.value.password)
      .subscribe(
        async (response) => {
          if (response.id != null) {
           
            this.globals.isloggedIn = true;
            this.globals.guestLogin = false;

            this.localStorageService.setLogin('isLogin', JSON.stringify(true));
            this.localStorageService.setBusinessId(
              'BusinessId',
              response.business_id
            );
            this.localStorageService.setQrText('QrText', response.qr_text);
            this.localStorageService.setUdId('UdId', response.udid);
            this.globals.udid = response.udid;
            this.localStorageService.setUrl('Url', response.url);
            this.localStorageService.setProfileComplete(
              'ProfileComplete',
              response.profile_complete
            );
            this.localStorageService.setPhoneVerified(
              'PhoneVerified',
              response.phone_verified
            );
            this.localStorageService.setPhone('Phone', response.phone);
            this.localStorageService.setMobileVerificationAmount(
              'MobileVerificationAmount',
              response.mobile_verification_amount
            );
            this.localStorageService.setId('Id', response.id);
            this.localStorageService.setLastName('LastName', response.lastname);
            this.localStorageService.setFirstName(
              'FirstName',
              response.first_name
            );
            this.localStorageService.setEmail('Email', response.email);
            this.localStorageService.setDateJoined(
              'DateJoined',
              response.date_joined
            );
            this.localStorageService.setCustomerType(
              'CustomerType',
              response.customer_type
            );
            this.localStorageService.setBirthday('Birthday', response.birthday);
            this.localStorageService.setAnniversary(
              'Anniversary',
              response.anniversary
            );

            const userData = {
              email: response.email || '',
              udid: response.udid || '',
              firstName: response.firstname || '',
              lastName: response.lastname || '',
              phone: response.phone || '',
              image: response.url || '',
              ID: response.id || '',
              date: response.date_joined || '',
              phone_verify: response.phone_verified || false,
              birthday: response.birthday || '',
              aniversary: response.anniversary || ''
            };

            if (this.platform.is('cordova')) {
              try {
                await this.nativeStorage.setItem('user', userData);
              } catch (error) {
                console.error('Error storing user data:', error);
              }
            }
            const redirect = this.authRedirectService.getRedirectUrl();

            if (
              this.globals.branch_enabled == 1 &&
              this.globals.franchise_enabled == false
            ) {
              console.log('backtesting','mobile');
              // this.navCTRL.navigateBack('tabs/tabs/home');
              if (redirect) {
                this.router.navigate([redirect], { replaceUrl: true });
              } else {
                this.navCTRL.navigateRoot('tabs/tabs/home'); // default post-login page
              }
            }
             else {
              if (redirect) {
                this.router.navigate([redirect], { replaceUrl: true });
              } else {
                this.navCTRL.navigateRoot('/order'); // default post-login page
              }
              console.log('backtesting','web');
              // this.navCTRL.navigateRoot('/order');
            }

          } else {
            const alert = await this.alertCtrl.create({
              header: 'Login Failed',
              message: 'Incorrect Email/Password',
              buttons: ['OK'],
            });
            await alert.present();
          }
        },
        async (error) => {
          console.log(error);
          const alert = await this.alertCtrl.create({
            header: 'Error',
            message: 'No response from server.Check internet connection.',
            buttons: ['OK'],
          });
          await alert.present();
        }
      );
  }
  goToForget() {
    this.navCTRL.navigateRoot('/forgot-password');
  }
  
  get errorControl() {
    return this.loginForm.controls;
  }
  close() {   
    this.navCTRL.back(); 
  }

  togglePassword() {
    console.log('toggle');
    this.PassType = (<HTMLInputElement>document.getElementById('pass')).type;

    if (this.PassType === 'password') {
      console.log('toggle', this.PassType);

      this.PassType = 'text';
      (<HTMLInputElement>document.getElementById('pass')).type = this.PassType;
    } else {
      this.PassType = 'password';
      (<HTMLInputElement>document.getElementById('pass')).type = this.PassType;
      console.log('toggle', this.PassType);
    }
  }
  terms() {
    this.router.navigate(['terms-conditions']);
    this.modalCtrl.dismiss();
  }
  openPrivacy() {
    this.router.navigate(['privacy-policy']);
    this.modalCtrl.dismiss();

    // this.modal
  }
  signUp() {
    this.navCTRL.navigateRoot('/sign-up');
  }
  async pageLoading() {
    this.loading = await this.loadingCtrl.create({
      message: '<img src="assets/animation/loader2.svg" alt="loading...">',
      cssClass: 'custom_loading',
    });
    await this.loading.present();
  }

  async dismissLoading() {
    if (this.loading) {
      await this.loading.dismiss();
      this.loading = null;
    }
  }
}
